import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyPDFDownloader } from 'src/app/constants/download-pdf';
import { ReservationSummary } from 'src/app/model/reservation.model';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-event-reservations',
  templateUrl: './event-reservations.component.html',
  styleUrls: ['./event-reservations.component.scss'],
  standalone: false
})
export class EventReservationsComponent implements OnInit {

  private pdfDownloader: MyPDFDownloader = new MyPDFDownloader();

  columns = [
    {
      columnDef: 'profile',
      header: 'event_reserv.int',
      cell: (element: ReservationSummary) => `${element.displayName}`,
    },
    {
      columnDef: 'creation',
      header: 'event_reserv.data',
      cell: (element: ReservationSummary) => `${element.creation_datetime}`,
    },
    {
      columnDef: 'occurence',
      header: 'event_reserv.event',
      cell: (element: ReservationSummary) => `${element.event_occurrence_datetime}`,
    },

  ];

  dataSource: any;
  displayedColumns = this.columns.map(c => c.columnDef);

  constructor(
    public dialogRef: MatDialogRef<EventReservationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService) { }

  ngOnInit(): void {
    this.dataSource = this.data.associated_reservations;

    this.displayedColumns = this.displayedColumns.concat(["status"]);
    this.displayedColumns = this.displayedColumns.concat(["can_edit"]);
    if (this.userService.isEmployeeWithoutPassenger()) {
      this.displayedColumns = this.displayedColumns.concat(["numeroPasseggeri"]);
    } else {
      this.displayedColumns = this.displayedColumns.concat(["download"]);
    }
  }

  edit(index: number) {
    this.close(this.data.associated_reservations[index]);
  }

  download(index: number) {
    this.pdfDownloader.downloadTickets(
      {
        event_name: this.data.event_name,
        event_datetime: this.data.associated_reservations[index].event_ticket_datetime,
        event_ticket_file_name: this.data.associated_reservations[index].ticket_file_name,
        event_long_description: this.data.event_long_description,
      },
      [{
        displayName: this.data.associated_reservations[index].displayName,
        badgeNumber: this.data.associated_reservations[index].badgeNumber
      }],
      this.userService.lang!
    );
  }

  close(res?: string) {
    this.dialogRef.close(
      res
    );
  }

}
